import React from 'react'

interface IModalContextData {
  isOpen: boolean
  toggleIsOpen: () => void
}

export enum ModalContextName {
  BookDemo = 'book-demo',
  ContactUs = 'contact-us',
  BookDemo2 = 'book-demo-2',
}

function getInitialState(): IModalContextData {
  return {
    isOpen: true,
    toggleIsOpen: () => {
      throw new Error('Not Implemented')
    },
  }
}

const ModalContext: React.Context<{
  [key in ModalContextName]: IModalContextData
}> = React.createContext({
  [ModalContextName.BookDemo]: getInitialState(),
  [ModalContextName.ContactUs]: getInitialState(),
  [ModalContextName.BookDemo2]: getInitialState(),
})

const useModals = () => {
  const [isBookDemoOpen, setBookDemoOpen] = React.useState(false)
  const [isBookDemo2Open, setBookDemo2Open] = React.useState(false)
  const [isContactUsOpen, setContactUsOpen] = React.useState(false)

  const toggleBookDemoIsOpen = React.useCallback(() => {
    return setBookDemoOpen((open) => !open)
  }, [])
  const toggleBookDemo2IsOpen = React.useCallback(() => {
    return setBookDemo2Open((open) => !open)
  }, [])

  const toggleContactUsIsOpen = React.useCallback(() => {
    return setContactUsOpen((open) => !open)
  }, [])

  return {
    'book-demo': { isOpen: isBookDemoOpen, toggleIsOpen: toggleBookDemoIsOpen },
    'book-demo-2': {
      isOpen: isBookDemo2Open,
      toggleIsOpen: toggleBookDemo2IsOpen,
    },
    'contact-us': {
      isOpen: isContactUsOpen,
      toggleIsOpen: toggleContactUsIsOpen,
    },
  }
}

export { useModals }

export default ModalContext
